module.exports = __webpack_public_path__ + "static/media/circleObs.cb96ae2b.png";